import { request } from '@/api';

/**
 * /auth/logout
 * 登出
 */
export const logoutApi = () =>
  request.post('/auth/logout', undefined, {
    allowCancel: false,
  });
